import type { ActiveRoom } from '@patrianna/shared-patrianna-types/store/BingoModule'
import type { GameProductShort } from '@patrianna/shared-patrianna-types/store/GameModule'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import { getGameKeyFromName } from './types'
import type { BingoRoomJackpot, BingoRoomWs, BingoState, BingoTypeJackpots } from './types'

const normalizeCurrency = (currency: string): 'GC' | 'SC' => (currency === 'GOLD' || currency === 'GC' ? 'GC' : 'SC')

const initialState: BingoState = {
  products: [],
  rooms: [],
  bingoRoomsJackpots: {},
  gameJackpots: {},
}

export const bingoSlice = createSlice({
  name: 'bingo',
  initialState,
  reducers: {
    saveBingoProducts: (state, action: PayloadAction<{ products: Array<GameProductShort> }>) => {
      state.products = action.payload.products
    },
    saveBingoRooms: (state, action: PayloadAction<{ rooms: Array<ActiveRoom> }>) => {
      state.rooms = action.payload.rooms
    },
    saveBingoRoomsJackpots: (state, action: PayloadAction<BingoRoomWs[]>) => {
      const jackpots = { ...state.bingoRoomsJackpots }
      const gameJackpots = { ...state.gameJackpots }

      action.payload.forEach(({ roomId, jackpotPrize, currency, bingoType, name }) => {
        const normalizedCurrency = normalizeCurrency(currency)
        const gameKey = name ? getGameKeyFromName(name) : undefined
        const jackpot: BingoRoomJackpot = {
          jackpotPrize,
          currency: normalizedCurrency,
          bingoType,
          gameKey,
        }
        jackpots[String(roomId)] = jackpot

        if (gameKey) {
          const typeJackpots: BingoTypeJackpots = {
            ...(gameJackpots[gameKey] ?? {}),
            [normalizedCurrency]: jackpot,
          }
          gameJackpots[gameKey] = typeJackpots
        }
      })

      state.bingoRoomsJackpots = jackpots
      state.gameJackpots = gameJackpots
    },
  },
})

export type ActionsTypes = ReturnType<InferValueTypes<typeof bingoSlice.actions>>
export const { actions } = bingoSlice
